import { fromJS } from 'immutable';
import * as constants from './constants';

const defaultState = fromJS({
  submitState: '',
  domain: [],
  patent: [],
  operation: [],
  maturity : [],
  demandtype: [],
  msg: [],
});

const handlePulishData = (state, action) => {
  return state.merge({
    // submitState: fromJS(action.submitState),
    domain: fromJS(action.domain),
    patent: fromJS(action.patent),
    operation: fromJS(action.operation),
    maturity : fromJS(action.maturity),
    demandtype: fromJS(action.demandtype)
  });
}

const handleSubmitState = (state, action) => {
  return state.merge({
    submitState: fromJS(action.submitState),
    msg: fromJS(action.msg)
  });
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case constants.GET_INIT_DATA:
      return handlePulishData(state, action);
    case constants.SUBMIT_STATE:
      return handleSubmitState(state, action);
    default:
      return state;
  }
}